import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    className?: string;
    /** Optional leading icon rendered before the title (mock pattern: accent-colored glyph). */
    icon?: React.ReactNode;
    /** Optional info tooltip rendered as an "ⓘ" after the title (mock pattern). */
    infoTooltip?: string;
    /** Optional override for the title's typography (e.g. profile uses 36px/700 per mock). */
    titleClassName?: string;
}

const InfoIcon: React.FC<{ title: string }> = ({ title }) => (
    <span className="w-5 h-5 text-snapfy-text-secondary cursor-help inline-block align-middle" title={title}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="w-full h-full">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
        </svg>
    </span>
);

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children, className = '', icon, infoTooltip, titleClassName = '' }) => {
    return (
        <div className={`mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 ${className}`}>
            <div>
                <h1 className={`text-3xl font-black text-snapfy-text-primary mb-2 flex items-center gap-3 ${titleClassName}`}>
                    {icon && <span className="w-8 h-8 text-snapfy-primary inline-block shrink-0">{icon}</span>}
                    <span>{title}</span>
                    {infoTooltip && <InfoIcon title={infoTooltip} />}
                </h1>
                {subtitle && <p className="text-snapfy-text-secondary text-lg">{subtitle}</p>}
            </div>
            {children && (
                <div className="flex items-center gap-3">
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
